module.exports = __webpack_public_path__ + "static/media/penelope.7f8d15bc.jpg";